import React from 'react';
import styled, { css } from 'styled-components';
import radio_circle from 'images/icon/radio_circle.png';
import m_radio_circle from 'images/m/radio_circle.png';

const sizes = {
  large: {
    width: '24px',
    height: '24px',
    lineHeight: '24px',
    backgroundSize: '12px auto',
    backgroundPosition: 'center top 6px'
  },
  medium: {
    width: '18px',
    height: '18px',
    lineHeight: '18px',
    backgroundSize: '10px auto',
    backgroundPosition: 'center'
  }
}

const sizeStyles = css`
  ${({ size }) => css`
    flex: ${sizes[size].width} 0 0;
    width: ${sizes[size].width};
    height: ${sizes[size].height};
    line-height: ${sizes[size].lineHeight};
    background-size: ${sizes[size].backgroundSize};
    background-position: ${sizes[size].backgroundPosition};
  `}
`

const RadioboxContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-right:10px;
  & input[type="radio"] {
    position: absolute;
    width:1px;
    height:1px;
    padding:0;
    margin:-1px;
    overflow:hidden;
    clip:rect(0,0,0,0);
    border:0;
  }
  & input[type="radio"] + label {
    display:inline-flex;
    position:relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    line-height: ${({ size }) => sizes[size].lineHeight};
    font-size: 15px;
    word-break: break-all;
    &::before{
      content:'';
      display:inline-block;
      margin: 0 10px 0 0;
      text-align:center; 
      vertical-align:middle;
      background-color: #fff;
      background-repeat: no-repeat;
      border:1px solid #ccc;
      border-radius:50%;
      ${sizeStyles};
    }
  }
  & input[type="radio"]:checked + label:before {
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(${radio_circle});
    border:1px solid #1EA0FA;
    @media only screen and (max-width: 960px) {
      background-image: url(${m_radio_circle});
    }
    ${sizeStyles};
  }
`

function Radiobox({ id, name, checked, value, onChange, label, size }) {
  return (
    <RadioboxContainer size={size}>
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        value={value}
        onChange={onChange}
      />
      <label htmlFor={id}>{label}</label>
    </RadioboxContainer>
  )
}

Radiobox.defaultProps = {
  size: 'medium'
}

export default Radiobox;